import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TimeScanningService } from "../../shared/data.service";

@Component({
	selector: "caass-scan-point-manual-alert",
	templateUrl: "./scan-point-manual-alert.component.html",
	styleUrls: ["./scan-point-manual-alert.component.css"],
})
export class ScanPointManualAlertComponent implements OnInit {
	constructor(private scanService: TimeScanningService) {}

	ngOnInit(): void {
		this.LoadAlertsForPerson();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////
	AudienceMode: any = "Student";
	@Input() FacilityID: any;
	@Input() SelectedPerson: any;

	//Table Data
	lstAlerts: any = [];
	SelectedEntry: any = null;
	cols: any = [
		{ field: "AlertID", header: "Alert ID" },
		{ field: "AlertCD", header: "Code" },
		{ field: "Message", header: "Description" },
	];

	pagefirst: number = 0;
	pagerows: number = 5;

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////

	LoadAlertsForPerson() {
		var result = this.scanService.LoadAlertsForPerson("", this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.lstAlerts = response;
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	/////////////////////////////////////////////////////////////////
}
